import { FireCMSTranslations } from "../types/translations";

export const hi: FireCMSTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "सहेजें",
    create: "बनाएं",
    create_copy: "प्रतिलिपि बनाएं",
    save_and_close: "सहेजें और बंद करें",
    create_copy_and_close: "प्रतिलिपि बनाएं और बंद करें",
    create_and_close: "बनाएं और बंद करें",
    discard: "रद्द करें (Discard)",
    clear: "साफ़ करें",
    cancel: "रद्द करें (Cancel)",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "संपादित करें",
    copy: "कॉपी करें",
    delete: "हटाएं",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "हटाएं?",
    delete_confirmation_body: "इससे इकाई (entity) हटा दी जाएगी। क्या आप सुनिश्चित हैं?",
    delete_multiple_confirmation_body: "इससे चयनित इकाइयां (entities) हटा दी जाएंगी। क्या आप सुनिश्चित हैं?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "सहेजे नहीं गए परिवर्तन",
    unsaved_changes_body: "आपके पास सहेजे नहीं गए परिवर्तन हैं। क्या आप उन्हें रद्द करना चाहते हैं?",
    discard_changes: "परिवर्तन रद्द करें",
    keep_editing: "संपादन जारी रखें",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "खोजें",
    find_by_id: "ID द्वारा खोजें",
    find_entity_by_id: "ID द्वारा इकाई खोजें",
    filter: "फ़िल्टर",
    filters: "फ़िल्टर",
    clear_filter: "फ़िल्टर साफ़ करें",
    clear_filter_sort: "फ़िल्टर/सॉर्ट साफ़ करें",
    clear_sort: "सॉर्ट साफ़ करें",
    no_items: "कोई आइटम नहीं",
    no_entries_found: "कोई प्रविष्टि नहीं मिली",
    all_entries_loaded: "सभी {{count}} प्रविष्टियाँ लोड हो गईं",
    create_your_first_entry: "अपनी पहली प्रविष्टि बनाएं",
    no_results_filter_sort: "लागू किए गए फ़िल्टर/सॉर्ट के साथ कोई परिणाम नहीं",
    add: "जोड़ें",
    remove: "हटाएं",
    multiple_entities: "एकाधिक इकाइयां",
    unsaved_changes: "आपके पास {{collectionName}} में सहेजे नहीं गए परिवर्तन हैं।",
    so_empty: "इतना खाली...",
    no_results: "लागू किए गए फ़िल्टर/सॉर्ट के साथ कोई परिणाम नहीं",
    refresh_data: "डेटा रीफ़्रेश करें",
    dark_mode: "डार्क",
    light_mode: "लाइट",
    system_mode: "सिस्टम",
    ok: "ठीक है",
    save_collection_config: "संग्रह संरचना सहेजें",
    search_for_more_icons: "और आइकन खोजें…",
    ai_modified: "AI द्वारा संशोधित",
    size_label: "आकार",
    group_by: "इसके द्वारा समूहित करें",
    initialize_kanban_order: "कानबन क्रम प्रारंभ करें",
    copy_id: "ID कॉपी करें",
    add_specific: "विशिष्ट {{name}} जोड़ें",
    select_specific: "विशिष्ट {{name}} चुनें",
    select_from: "{{name}} से चुनें",
    done: "हो गया",
    log_out: "लॉग आउट",
    license_needed: "लाइसेंस आवश्यक है",
    license_description: "FireCMS PRO का उपयोग करने के लिए आपको एक वैध लाइसेंस की आवश्यकता है। कृपया अधिक जानकारी के लिए {{email}} पर संपर्क करें।",
    column_cannot_be_edited: "इस कॉलम को सीधे संपादित नहीं किया जा सकता",
    close: "बंद करें",
    unsaved_local_changes: "सहेजे नहीं गए स्थानीय परिवर्तन",
    unsaved_local_changes_description: "इस दस्तावेज़ को स्थानीय स्तर पर संपादित किया गया था और इसमें सहेजे नहीं गए परिवर्तन हैं। यदि आप इन्हें लागू नहीं करते हैं तो ये स्थानीय परिवर्तन खो जाएंगे।",
    preview_changes: "परिवर्तनों का पूर्वावलोकन करें",
    apply_changes: "परिवर्तन लागू करें",
    discard_local_changes: "स्थानीय परिवर्तन रद्द करें",
    preview_local_changes: "स्थानीय परिवर्तनों का पूर्वावलोकन करें",
    preview_local_changes_description: "ये वे स्थानीय परिवर्तन हैं जिन्हें फॉर्म पर लागू किया जाएगा।",
    type: "प्रकार",
    string: "स्ट्रिंग",
    number: "नंबर",
    boolean: "बूलियन",
    date: "दिनांक",
    map: "मैप",
    array: "ऐरे",
    arrays_of_arrays_not_supported: "ऐरे के ऐरे समर्थित नहीं हैं।",
    data_type_not_supported: "डेटा प्रकार {{dataType}} अभी समर्थित नहीं है",
    passkey_error_unsupported: "आपका डिवाइस या ब्राउज़र पासकी का समर्थन नहीं करता है।",

    admin: "एडमिन",
    home: "होम",
    this_form_has_errors: "इस फॉर्म में त्रुटियाँ हैं",
    error_loading_navigation: "नेविगेशन लोड करने में त्रुटि",
    error_loading_auth: "प्रमाणीकरण लोड करने में त्रुटि",
    this_form_has_been_modified: "इस फॉर्म को संशोधित किया गया है",
    current_form_in_sync: "वर्तमान फॉर्म डेटाबेस के साथ सिंक में है",
    open_in_console: "कंसोल में खोलें",
    collection_does_not_exist: "निर्दिष्ट संग्रह मौजूद नहीं है। कंसोल चेक करें",
    unexpected_value: "अप्रत्याशित मान",
    unexpected_value_click_to_edit: "अप्रत्याशित मान। संपादित करने के लिए क्लिक करें",
    unexpected_reference_value: "अप्रत्याशित संदर्भ मान। संपादित करने के लिए क्लिक करें",
    copy_url_to_clipboard: "क्लिपबोर्ड पर URL कॉपी करें",
    open_image_in_new_tab: "नई टैब में छवि खोलें",
    reference_not_set: "संदर्भ सेट नहीं है",
    reference_does_not_exist: "संदर्भ मौजूद नहीं है",
    entity_not_found: "इकाई नहीं मिली",
    file_not_found: "फ़ाइल नहीं मिली",
    unsaved_changes_in_entity: "आपके पास इस इकाई में सहेजे नहीं गए परिवर्तन हैं।",
    delete_this_role: "यह भूमिका हटाएं",
    no_roles_yet: "आपके पास अभी तक कोई भूमिका नहीं है।",
    create_default_roles: "डिफ़ॉल्ट भूमिकाएँ बनाएँ",
    delete_role_confirmation: "क्या आप वाकई इस भूमिका को हटाना चाहते हैं?",
    delete_this_user: "इस उपयोगकर्ता को हटाएं",
    no_users_yet: "अभी तक कोई उपयोगकर्ता नहीं है",
    add_logged_user_as_admin: "लॉग इन उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    add_current_user_as_admin: "वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    create_default_roles_and_add_admin: "डिफ़ॉल्ट भूमिकाएँ बनाएं और वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ें",
    delete_user_confirmation: "क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं?",
    create_your_users_and_roles: "अपने उपयोगकर्ता और भूमिकाएँ बनाएँ",
    no_users_or_roles_defined: "आपके पास कोई उपयोगकर्ता या भूमिका परिभाषित नहीं है। आप डिफ़ॉल्ट भूमिकाएँ बना सकते हैं और वर्तमान उपयोगकर्ता को एडमिन के रूप में जोड़ सकते हैं।",
    save_before_changing_schema: "स्कीमा बदलने से पहले आपको दस्तावेज़ सहेजना होगा",
    edit_schema_for_this_form: "इस फॉर्म के लिए स्कीमा संपादित करें",
    no_permissions_to_edit_collection: "आपके पास इस संग्रह को संपादित करने की अनुमति नहीं है",
    browser_does_not_support_audio: "आपका ब्राउज़र ऑडियो तत्व का समर्थन नहीं करता है।",
    user_not_found: "उपयोगकर्ता नहीं मिला: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "चयनित हटाएं",
    cannot_delete_selected: "आपने कम से कम एक इकाई का चयन किया है जिसे आप हटा नहीं सकते",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "जोड़ें",
    add_on_top: "शीर्ष पर जोड़ें",
    add_below: "नीचे जोड़ें",
    add_to_field: "{{fieldName}} में जोड़ें",
    value: "मान",
    key: "कुंजी",
    drag_drop_multiple: "कुछ फ़ाइलों को यहां खींचें और छोड़ें, या फ़ाइलों का चयन करने के लिए क्लिक करें। पुन: क्रमबद्ध करने के लिए खींचें।",
    drag_drop_single: "किसी फ़ाइल को यहां खींचें और छोड़ें, या किसी एक का चयन करने के लिए क्लिक करें",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "मेनू खोलें",
    close_drawer: "ड्रॉअर बंद करें",
    navigation_drawer: "नेविगेशन ड्रॉअर",

    // ─── Error states ─────────────────────────────────────────────
    error: "त्रुटि",
    error_uploading_file: "फ़ाइल अपलोड करने में त्रुटि",
    error_deleting: "हटाने में त्रुटि",
    error_before_delete: "हटाने से पहले त्रुटि",
    error_updating_asset: "एसेट अपडेट करने में त्रुटि",
    error_deleting_asset: "एसेट हटाने में त्रुटि",
    error_firestore_index: "इस क्वेरी के लिए Firestore इंडेक्स आवश्यक है।",
    create_index: "इंडेक्स बनाएं",
    value_is_not_reference: "मान एक संदर्भ नहीं है।",
    click_to_edit: "संपादित करने के लिए क्लिक करें",
    data_is_not_array_of_references: "डेटा संदर्भों का ऐरे नहीं है",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "लोड हो रहा है",
    local_changes_applied: "स्थानीय परिवर्तन फॉर्म पर लागू किए गए",
    local_changes_discarded: "स्थानीय परिवर्तन रद्द किए गए",
    are_you_sure_leave: "क्या आप वाकई इस पृष्ठ को छोड़ना चाहते हैं?",
    see_console_details: "अधिक विवरण के लिए कंसोल देखें।",
    drop_here_create_group: "नया समूह बनाने के लिए यहां छोड़ें",
    filter_for_null_values: "रिक्त (नल्ल) मानों के लिए फ़िल्टर करें",
    value_updated_elsewhere: "इस मान को कहीं और अपडेट किया गया है",
    add_property: "विशेषता (प्रॉपर्टी) जोड़ें",
    edit_name: "{{name}} संपादित करें",
    this_entity_not_exist: "यह इकाई डेटाबेस में मौजूद नहीं है",
    internal_error: "आंतरिक त्रुटि (Internal ERROR)",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "समूह का नाम बदलें",
    group_name_label: "समूह का नाम",
    group_name_empty_error: "समूह का नाम खाली नहीं हो सकता।",
    group_name_exists_error: "यह समूह नाम पहले से मौजूद है।",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "संग्रह खोजें",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "दृश्य",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "अतिरिक्त संग्रह जोड़ने से पहले आपको अपनी इकाई को सहेजना होगा",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "पृष्ठ नहीं मिला",
    page_not_found_body: "यह पृष्ठ मौजूद नहीं है या आपके पास इस तक पहुंच नहीं हो सकती है",
    back_to_home: "होम पर वापस जाएँ",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "डिफ़ॉल्ट संग्रह दृश्य",
    table_view: "तालिका",
    cards_view: "कार्ड्स",
    kanban_view: "कानबन",
    choose_how_entities_displayed_default: "चुनें कि डिफ़ॉल्ट रूप से इकाइयां कैसे प्रदर्शित होनी चाहिए",

    document_view: "दस्तावेज़ दृश्य",
    side_panel: "साइड पैनल",
    full_screen: "पूरी स्क्रीन",
    should_documents_opened_full_screen: "क्या दस्तावेज़ों को फ़ुल स्क्रीन में या इनलाइन साइड डायलॉग में खोला जाना चाहिए",

    select_custom_view: "कस्टम दृश्य चुनें",
    no_custom_views_defined: "कोई कस्टम दृश्य परिभाषित नहीं है। इस डायलॉग का उपयोग करने से पहले कस्टमाइज़ेशन सेटिंग्स में अपने कस्टम दृश्य परिभाषित करें।",

    select_custom_action: "कस्टम कार्रवाई चुनें",
    no_custom_actions_defined: "कोई कस्टम कार्रवाई परिभाषित नहीं है। इस डायलॉग का उपयोग करने से पहले कस्टमाइज़ेशन सेटिंग्स में अपनी कस्टम कार्रवाइयाँ परिभाषित करें।",

    no_collections_found: "कोई संग्रह नहीं मिला",
    start_building_collections: "FireCMS में आसानी से संग्रह बनाना शुरू करें। उन्हें अपने मौजूदा डेटाबेस डेटा पर मैप करें, फ़ाइलों से आयात करें या हमारे टेम्प्लेट का उपयोग करें।",
    create_first_collection: "अपना पहला संग्रह बनाएं",
    define_collections_programmatically: "आप संग्रहों को प्रोग्रामेटिक रूप से भी परिभाषित कर सकते हैं।",
    edit_collection: "संग्रह संपादित करें",
    no_permissions_edit_collection: "आपके पास इस संग्रह को संपादित करने की अनुमति नहीं है",
    no_permissions_create_collection: "आपके पास संग्रह बनाने की अनुमति नहीं है",
    create_collection: "संग्रह बनाएं",
    update_collection: "संग्रह अपडेट करें",

    new_collection: "नया संग्रह",
    add_new_collection: "नया संग्रह जोड़ें",
    collection_with_name: "{{name}} संग्रह",
    change_icon: "आइकन बदलें",
    is_subcollection_of: "यह इसका उपसंग्रह (subcollection) है",
    name: "नाम",
    collection_name_description: "इस संग्रह का नाम, आमतौर पर एक बहुवचन नाम (जैसे उत्पाद)",
    path: "पथ (Path)",
    relative_path_to_parent: "मूल (parent) का सापेक्ष पथ (मूल पथ को शामिल करने की आवश्यकता नहीं है)",
    path_in_database: "वह पथ जिसमें यह संग्रह संग्रहीत है, डेटाबेस में",
    singular_name: "एकवचन नाम",
    singular_name_description: "वैकल्पिक रूप से अपनी इकाइयों के लिए एकवचन नाम परिभाषित करें",
    description: "विवरण",
    description_of_collection: "संग्रह का विवरण, आप मार्कडाउन का उपयोग कर सकते हैं",
    collection_id: "संग्रह ID",
    collection_id_description: "यह ID इस संग्रह की पहचान करता है। आम तौर पर पथ के समान।",
    collection_group: "संग्रह समूह",
    collection_group_description: "एक संग्रह समूह में एक ही पथ वाले सभी संग्रह होते हैं। यह आपको एक साथ कई संग्रहों पर क्वेरी करने की अनुमति देता है।",
    advanced_settings: "उन्नत सेटिंग्स",
    doc_history_global: "दस्तावेज़ इतिहास संशोधन सक्षम (यदि विश्व स्तर पर सक्षम हैं)",
    doc_history_enabled: "दस्तावेज़ इतिहास संशोधन सक्षम",
    doc_history_not_enabled: "दस्तावेज़ इतिहास संशोधन सक्षम नहीं",
    doc_history_description: "सक्षम होने पर, इस संग्रह के प्रत्येक दस्तावेज़ में परिवर्तनों का इतिहास होगा। यह ऑडिटिंग उद्देश्यों के लिए उपयोगी है। डेटा आपके डेटाबेस में दस्तावेज़ के एक उपसंग्रह में संग्रहीत होता है, जिसे __history कहा जाता है।",
    document_id_generation: "दस्तावेज़ ID जनरेशन",
    code_defined: "कोड परिभाषित",
    users_must_define_id: "उपयोगकर्ताओं को एक ID परिभाषित करनी होगी",
    users_can_define_id: "उपयोगकर्ता एक ID परिभाषित कर सकते हैं, लेकिन इसकी आवश्यकता नहीं है",
    doc_id_auto_generated: "दस्तावेज़ ID स्वचालित रूप से उत्पन्न होती है",
    config_doc_id_generation: "नई इकाइयां बनाते समय दस्तावेज़ ID कैसे उत्पन्न होती हैं, इसे कॉन्फ़िगर करें।",
    enable_text_search: "इस संग्रह के लिए पाठ खोज (text search) सक्षम करें",
    text_search_description: "इस संग्रह के लिए पाठ खोज की अनुमति दें। यदि आपने पाठ खोज प्रतिनिधि निर्दिष्ट नहीं किया है, तो यह अंतर्निहित स्थानीय पाठ खोज का उपयोग करेगा। बड़े संग्रहों के लिए इसकी अनुशंसा नहीं की जाती है, क्योंकि इससे प्रदर्शन और लागत संबंधी समस्याएं हो सकती हैं।",
    database_id: "डेटाबेस ID",
    default_text: "(डिफ़ॉल्ट)",

    custom_actions: "कस्टम कार्रवाइयां",
    more_info: "अतिरिक्त जानकारी",
    define_custom_actions_cli: "CLI के साथ अपलोड करके अपनी स्वयं की कस्टम कार्रवाइयां परिभाषित करें।",
    action_defined_in_code: "यह क्रिया कोड में कुंजी (key) के साथ परिभाषित की गई है",
    add_custom_entity_action: "कस्टम इकाई कार्रवाई जोड़ें",
    remove_this_action: "यह क्रिया हटाएँ?",
    remove_action_warning: "यह कोई डेटा नहीं हटाएगा, केवल CMS में कार्रवाई को हटाएगा",

    subcollections_of: "के उपसंग्रह",
    add_subcollection: "उपसंग्रह जोड़ें",
    custom_views: "कस्टम दृश्य",
    define_custom_views_cli: "CLI के साथ अपलोड करके अपने स्वयं के कस्टम दृश्य परिभाषित करें।",
    view_defined_in_code: "यह दृश्य कोड में कुंजी (key) के साथ परिभाषित किया गया है",
    add_custom_entity_view: "कस्टम इकाई दृश्य जोड़ें",
    delete_this_subcollection: "इस उपसंग्रह को हटाएं?",
    remove_collection_warning: "यह कोई डेटा नहीं हटाएगा, केवल CMS में संग्रह को हटाएगा",
    remove_this_view: "यह दृश्य हटाएँ?",
    remove_view_warning: "यह कोई डेटा नहीं हटाएगा, केवल CMS में दृश्य को हटाएगा",

    no_collection_selected: "कोई संग्रह नहीं चुना गया",
    code_for_collection: "संग्रह के लिए कोड",
    use_config_define_json: "संग्रह को JSON प्रारूप में परिभाषित करने के लिए इस कॉन्फ़िगरेशन का उपयोग करें।",
    customise_collection_code: "यदि आप कोड में संग्रह को अनुकूलित करना चाहते हैं, तो आप इस संग्रह कोड को अपने CMS ऐप कॉन्फ़िगरेशन में जोड़ सकते हैं।",
    copied: "कॉपी किया गया",

    property_cant_be_edited: "इस विशेषता को संपादित नहीं किया जा सकता",
    property_not_editable_description: "आपके पास इसे संपादित करने की अनुमति नहीं हो सकती है या इसे कोड में 'editable' ध्वज (flag) के 'false' पर सेट होने के साथ परिभाषित किया गया है।",
    delete_this_property: "यह विशेषता हटाएँ?",
    delete_property_warning: "यह कोई डेटा नहीं हटाएगा, केवल संग्रह को संशोधित करेगा।",
    error_must_specify_id: "आपको फ़ील्ड के लिए एक id निर्दिष्ट करना होगा",
    error_id_format: "id में केवल अक्षर, संख्याएं और अंडरस्कोर (_) हो सकते हैं, और यह किसी संख्या से शुरू नहीं हो सकता",
    error_id_already_exists: "इस ID के साथ पहले से ही एक और फ़ील्ड मौजूद है",
    error_must_specify_title: "आपको फ़ील्ड के लिए एक शीर्षक निर्दिष्ट करना होगा",
    custom_or_other: "कस्टम/अन्य",
    select_property_widget: "एक प्रॉपर्टी विजेट का चयन करें",
    error_changing_data_type: "यह विजेट प्रारंभ में चयनित विजेट की तुलना में एक अलग डेटा प्रकार का उपयोग करता है। यह मौजूदा डेटा के साथ त्रुटियों का कारण बन सकता है।",
    required: "आवश्यक",

    enum_form_dialog: "Enum फॉर्म डायलॉग",
    imported_data_preview: "आयात किए गए डेटा का पूर्वावलोकन",
    entities_with_same_id_overwritten: "समान id वाली इकाइयों को अधिलेखित (overwritten) किया जाएगा",
    collection_editor: "संग्रह संपादक",
    properties_in_this_group: "इस समूह में विशेषताएं",
    data_property_mapping: "डेटा संपत्ति मानचित्रण (मॅपिंग)",
    property_edit_view: "प्रॉपर्टी संपादन दृश्य",
    all_of_these: "ये सभी",
    any_of_these: "इनमें से कोई भी",

    only_admins_edit_roles: "केवल व्यवस्थापक (Admins) ही भूमिकाएँ संपादित कर सकते हैं",
    error_user_not_found: "उपयोगकर्ता नहीं मिला",
    role: "भूमिका",
    name_of_this_role: "इस भूमिका का नाम",
    id_of_this_role: "इस भूमिका की ID",
    create_entities: "इकाइयाँ बनाएँ",
    read_entities: "इकाइयाँ पढ़ें",
    update_entities: "इकाइयाँ अपडेट करें",
    delete_entities: "इकाइयाँ हटाएँ",
    all_collections: "सभी संग्रह",
    create_entities_in_collections: "संग्रहों में इकाइयाँ बनाएँ",
    access_all_data_in_every_collection: "हर संग्रह में सभी डेटा तक पहुँचें",
    update_data_in_any_collection: "किसी भी संग्रह में डेटा अपडेट करें",
    delete_data_in_any_collection: "किसी भी संग्रह में डेटा हटाएँ",
    allow_all_permissions_in_this_collections: "इन संग्रहों में सभी अनुमतियों की अनुमति दें",
    all: "सभी",
    customise_permissions_description: "आप उन अनुमतियों को अनुकूलित कर सकते हैं जो इस भूमिका से संबंधित उपयोगकर्ता प्रत्येक संग्रह की इकाइयों में कर सकते हैं",
    create_collections: "संग्रह बनाएँ",
    yes: "हाँ",
    no: "नहीं",
    can_user_create_collections: "क्या उपयोगकर्ता संग्रह बना सकता है",
    edit_collections: "संग्रह संपादित करें",
    only_own_collections: "केवल उसकी/उसकी अपनी",
    own: "अपनी",
    can_user_edit_collections: "क्या उपयोगकर्ता संग्रह संपादित कर सकता है",
    delete_collections: "संग्रह हटाएँ",
    can_user_delete_collections: "क्या उपयोगकर्ता संग्रह हटा सकता है",
    error_saving_role: "इस भूमिका को सहेजने में कोई त्रुटि हुई",
    create_role: "भूमिका बनाएँ",
    update: "अपडेट करें",

    only_admins_change_roles: "केवल व्यवस्थापक ही भूमिकाएँ बदल सकते हैं",
    must_be_at_least_one_admin: "कम से कम एक एडमिन होना चाहिए",
    logged_user_not_found: "लॉग इन उपयोगकर्ता नहीं मिला",
    user: "उपयोगकर्ता (User)",
    user_id: "उपयोगकर्ता ID",
    name_of_this_user: "इस उपयोगकर्ता का नाम",
    email_of_this_user: "इस उपयोगकर्ता का ईमेल",
    roles: "भूमिकाएँ",
    create_user: "उपयोगकर्ता बनाएँ",

    users: "उपयोगकर्ता (Users)",
    add_user: "उपयोगकर्ता जोड़ें",
    add_role: "भूमिका जोड़ें",
    is_admin: "एडमिन है",
    default_permissions: "डिफ़ॉल्ट अनुमतियाँ",
    created_on: "इस दिन बनाया गया",
    email: "ईमेल",
    id: "ID",
    read: "पढ़ें",

    column_in_file: "फ़ाइल में कॉलम",
    map_to_property: "प्रॉपर्टी में मैप करें",
    default_values: "डिफ़ॉल्ट मान",
    default_values_description: "आप अनमैप किए गए कॉलम और खाली मानों के लिए एक डिफ़ॉल्ट मान का चयन कर सकते हैं:",
    property: "विशेषता (Property)",
    default_value: "डिफ़ॉल्ट मान",
    autogenerate_id: "ID स्वतः उत्पन्न करें",
    id_column_description: "कॉलम जिसका उपयोग प्रत्येक दस्तावेज़ के लिए ID के रूप में किया जाएगा",
    do_not_set_value: "मान सेट न करें",
    set_value_to_true: "मान को true पर सेट करें",
    set_value_to_false: "मान को false पर सेट करें",
    drag_and_drop_file: "फ़ाइल को यहां खींचें और छोड़ें या अपलोड करने के लिए क्लिक करें",
    error_saving_data: "डेटा सहेजने में त्रुटि",
    retry: "पुनः प्रयास करें",
    saving_data: "डेटा सहेजा जा रहा है",
    entities_saved: "इकाइयाँ सहेजी गईं",
    do_not_close_tab: "इस टैब को बंद न करें अन्यथा आयात बाधित हो जाएगा",
    import: "आयात (Import)",
    import_data: "डेटा आयात करें",
    upload_file_description: "CSV, Excel या JSON फ़ाइल अपलोड करें और इसे अपने मौजूदा स्कीमा में मैप करें",
    back: "पीछे",
    next: "अगला",
    save_data: "डेटा सहेजें",
    use_column_as_id: "इस कॉलम को ID के रूप में उपयोग करें",
    do_not_import_property: "इस विशेषता को आयात न करें",
    entities_will_be_overwritten: "समान ID वाली इकाइयों को अधिलेखित (overwritten) किया जाएगा",
    data_imported_successfully: "डेटा सफलतापूर्वक आयात किया गया",
    export: "निर्यात (Export)",
    export_data: "डेटा निर्यात करें",
    download_table_csv: "इस तालिका की सामग्री को CSV के रूप में डाउनलोड करें",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "टाइमस्टैम्प के रूप में तिथियां",
    dates_as_strings: "स्ट्रिंग्स के रूप में तिथियां",
    flatten_arrays: "ऐरे को फ़्लैट करें",
    download: "डाउनलोड",
    large_number_of_documents: "इस संग्रह में बड़ी संख्या में दस्तावेज़ हैं ({{count}})।",
    include_undefined_values: "अपरिभाषित (undefined) मान शामिल करें",
    submit: "सबमिट करें",

    no_filterable_properties: "कोई फ़िल्टर करने योग्य गुण उपलब्ध नहीं हैं",
    apply_filters: "फ़िल्टर लागू करें",
    list: "सूची",
    cards: "कार्ड",
    board: "बोर्ड",
    initialize_kanban_order_desc: "यह उन सभी आइटम को अनुक्रमिक क्रम मान निर्दिष्ट करेगा जिनके पास एक नहीं है। आइटम प्रत्येक कॉलम के भीतर अपना वर्तमान क्रम बनाए रखेंगे।",
    kanban_view_not_available: "कानबन दृश्य उपलब्ध नहीं है",
    kanban_view_requires_enum: "कानबन दृश्य के लिए इकाइयों को कॉलम में समूहीकृत करने के लिए एनम (Enum) मानों वाली एक स्ट्रिंग संपत्ति की आवश्यकता होती है। कृपया इस दृश्य का उपयोग करने के लिए अपने संग्रह स्कीमा में एक Enum संपत्ति जोड़ें।",
    no_enum_values_configured: 'प्रॉपर्टी "{{property}}" के लिए कोई एनम मान कॉन्फ़िगर नहीं किया गया है',
    items_need_backfill: "कुछ आइटम के क्रम मान नहीं होते हैं। खींचें-और-छोड़ें (Drag-and-drop) पुनर्रचना को सक्षम करने के लिए प्रारंभ करें।",
    initialize: "प्रारंभ करें",
    confirm_multiple_delete: "एकाधिक विलोपन की पुष्टि करें?",
    delete_entity_confirm_title: "क्या आप इस {{entityName}} को हटाना चाहेंगे?",

    /** Recently extracted strings for collection editor */
    /** AI Collection Generator Popover */
    generate_collection_with_ai: "AI से संग्रह बनाएं",
    modify_collection_with_ai: "AI से संग्रह संशोधित करें",
    describe_collection_to_create: "वह संग्रह बताएं जिसे आप बनाना चाहते हैं।",
    describe_changes_to_make: "वे परिवर्तन बताएं जो आप इस संग्रह में करना चाहते हैं।",
    ai_placeholder_create: "उदा. नाम, मूल्य, विवरण और श्रेणी के साथ एक उत्पाद संग्रह बनाएं...",
    ai_placeholder_modify: "उदा. स्टोरेज के साथ एक थंबनेल छवि फ़ील्ड जोड़ें, मूल्य को आवश्यक बनाएं...",
    ai_assist: "AI सहायक",
    generating: "उत्पन्न हो रहा है...",

    this_is_subcollection_of: "यह इसका एक उपसंघ (subcollection) है",
    use_existing_paths_database: "अपने डेटाबेस में मौजूदा पथों में से एक का उपयोग करें:",
    describe_collection_ai: "AI को अपने संग्रह का वर्णन करें:",
    generate_with_ai: "AI के साथ जनरेट करें",
    create_from_json_config: "JSON कॉन्फ़िगरेशन से बनाएँ:",
    paste_json_config: "JSON कॉन्फ़िगरेशन पेस्ट करें",
    create_collection_from_file_formats: "फ़ाइल (csv, json, xls, xslx...) से एक संग्रह बनाएँ",
    select_template: "एक टेम्पलेट चुनें:",
    products: "उत्पाद",
    collection_products_subtitle: "छवियों, कीमतों और स्टॉक वाले उत्पादों का संग्रह",
    collection_users_subtitle: "ईमेल, नाम और भूमिकाओं वाले उपयोगकर्ताओं का एक संग्रह",
    blog_posts: "ब्लॉग पोस्ट",
    collection_blog_posts_subtitle: "छवियों, लेखकों और जटिल सामग्री के साथ ब्लॉग पोस्ट का एक संग्रह",
    pages: "पृष्ठ (Pages)",
    collection_pages_subtitle: "छवियों, लेखकों और जटिल सामग्री के साथ पृष्ठों का एक संग्रह",
    continue_from_scratch: "शुरुआत से जारी रखें",

    /** Admin views config */
    cms_users: "CMS उपयोगकर्ता",
    roles_menu: "भूमिकाएँ",
    project_settings: "परियोजना सेटिंग",
    firestore_manager: "Firestore मैनेजर",
    manage_your_firestore_data: "अपने Firestore डेटा का प्रबंधन करें",

    // ─── FireCMS Cloud Login ──────────────────────────────────────
    build_admin_panel_in_minutes: "मिनटों में अपना Firebase एडमिन पैनल बनाएं",
    go_live_instantly: "तुरंत लाइव जाएं:",
    create_production_ready_back_offices: "उत्पादन-तैयार बैक-ऑफ़िस बनाएं",
    without_the_frontend_hassle: "बिना किसी फ्रंटएंड परेशानी के।",
    automatic_setup: "स्वचालित सेटअप",
    from_your_existing_firestore_data: "अपने मौजूदा Firestore डेटा से।",
    seamless_real_time_firebase_integration: "निर्बाध रीयल-टाइम Firebase एकीकरण।",
    intuitive_spreadsheet_like_ui: "सहज ज्ञान युक्त स्प्रेडशीट जैसा यूजर इंटरफेस",
    your_whole_team_can_use: "जिसका आपकी पूरी टीम उपयोग कर सकती है।",
    focus_on_your_app: "अपने ऐप पर ध्यान केंद्रित करें,",
    not_the_admin_panel: "व्यवस्थापक पैनल पर नहीं।",
    join_our_newsletter: "हमारे न्यूज़लेटर से जुड़ें। बिना किसी स्पैम के, केवल महत्वपूर्ण अपडेट!",
    by_signing_in_you_agree_to_our: "साइन इन करके आप हमारे नियमों और शर्तों से सहमत होते हैं",
    terms_and_conditions: "नियम और शर्तें",
    and_our: "और हमारी गोपनीयता नीति",
    privacy_policy: "गोपनीयता नीति",
    firecms_cloud_google_disclosure: "FireCMS Cloud द्वारा Google API से प्राप्त जानकारी का उपयोग और किसी अन्य ऐप में स्थानांतरण निम्न का पालन करेगा",
    google_api_services_user_data_policy: "Google API सेवाएँ उपयोगकर्ता डेटा नीति",
    including_the_limited_use_requirements: "जिसमें सीमित उपयोग की आवश्यकताएं शामिल हैं।",
    email_password: "ईमेल/पासवर्ड",
    sign_in_with_google: "Google से साइन इन करें",

    // --- Auth error messages ---
    auth_user_not_found: "उपयोगकर्ता नहीं मिला",
    auth_wrong_password: "गलत पासवर्ड। कृपया पुनः प्रयास करें।",
    auth_user_disabled: "उपयोगकर्ता अक्षम है। कृपया समर्थन से संपर्क करें।",
    auth_account_exists_with_different_credential: "विभिन्न साइन-इन विधि के साथ खाता मौजूद है",
    auth_email_already_in_use: "ईमेल पहले से ही उपयोग में है",
    auth_google_permissions_required: "अपने Google Cloud प्रोजेक्ट प्रबंधित करने के लिए आपको अतिरिक्त अनुमतियाँ देने की आवश्यकता है",
    auth_invalid_email_password: "कृपया ईमेल और पासवर्ड दोनों दर्ज करें",
    auth_enter_email_first: "कृपया पहले अपना ईमेल दर्ज करें",
    auth_password_reset_sent: "पासवर्ड रीसेट ईमेल भेजा गया",
    auth_sign_in_account: "अपने खाते में प्रवेश करें",
    auth_create_new_account: "एक नया अकाउंट बनाएँ",
    auth_password: "पासवर्ड",
    auth_reset_password: "पासवर्ड रीसेट करें",
    auth_new_user: "नया उपयोगकर्ता?",
    auth_have_account: "क्या आपके पास एक खाता है?",
    auth_sign_in: "साइन इन करें",
    auth_sign_up: "साइन अप करें",

    // --- SaaS Subscriptions ---
    subscriptions: "सदस्यताएँ (Subscriptions)",
    manage_your_subscriptions_in_stripe: "Strpe (स्ट्राइप) में अपनी सदस्यताएं प्रबंधित करें",
    go_to_your_stripe_portal: "बिलिंग इतिहास देखने के लिए अपने उपयोगकर्ता स्ट्राइप पोर्टल पर जाएँ। ध्यान दें कि आप लॉग इन किए गए उपयोगकर्ता से जुड़ी सदस्यताओं को भी प्रबंधित कर सकते हैं।",
    your_pro_licenses: "आपके PRO लाइसेंस",
    create_new_license: "नया लाइसेंस बनाएं",
    create_subscriptions_in_this_section: "इस अनुभाग में केवल स्व-होस्ट (self hosted) किए गए FireCMS PRO के लिए सदस्यताएँ बनाएँ। यदि आप FireCMS Cloud का उपयोग कर रहे हैं, तो आप प्रोजेक्ट सेटिंग्स के भीतर से अपना प्रोजेक्ट अपग्रेड कर सकते हैं।",
    if_you_are_an_agency: "यदि आप एक एजेंसी हैं, तो आप अपने ग्राहकों को अपना लाइसेंस फिर से बेचने के लिए स्वतंत्र हैं।",
    if_you_have_any_questions: "यदि आपके कोई प्रश्न हैं या आपको मदद की आवश्यकता है, तो कृपया हमसे संपर्क करें",
    you_have_not_created_any_pro_licenses: "आपने अभी तक कोई FireCMS PRO लाइसेंस नहीं बनाया है",
    archive: "संग्रहीत (Archive)",
    licensed_projects_lowercase: "लाइसेंस प्राप्त प्रोजेक्ट्स",
    manage: "प्रबंधित करें",
    update_payment_method: "भुगतान विधि अपडेट करें",
    your_firecms_cloud_projects: "आपके FireCMS Cloud प्रोजेक्ट्स",
    status_active: "सक्रिय",
    status_trialing: "परीक्षण (ट्रायल)",
    status_past_due: "बकाया (Past due)",
    status_canceled: "रद्द",
    status_unpaid: "अवैतनिक",
    status_incomplete: "अपूर्ण",
    status_incomplete_expired: "अपूर्ण (समाप्त)",
    status_unknown: "अज्ञात",

    plan_free: "सदस्यता नहीं ली गई",
    plan_cloud_plus: "सदस्यता ली गई",
    plan_pro: "Pro",
    plan_unknown: "अज्ञात योजना",

    auto_setup_collections_button: "संग्रहों को स्वचालित रूप से सेट करें",
    auto_setup_collections_title: "संग्रहों की स्वचालित सेटअप",
    auto_setup_collections_desc: "अपने मौजूदा Firestore डेटा के आधार पर संग्रहों को स्वचालित रूप से सेट करें। FireCMS को आपके लिए परफेक्ट CMS कॉन्फ़िगर करने दें।",
    setting_up_collections: "संग्रह सेट किए जा रहे हैं",
    setting_up_collection: "{{name}} सेट किया जा रहा है",
    no_collections_found_to_setup: "सेट करने के लिए कोई संग्रह नहीं मिला",
    collections_have_been_setup: "संग्रहों को सेट कर दिया गया है",
    error_setting_up_collections: "संग्रह सेट करने में त्रुटि",
    setup_collections_title: "Set up collections",
    setup_collections_select_desc: "Select which collections to automatically set up:",
    select_all: "Select all",
    deselect_all: "Deselect all",
    setup_collections_confirm: "Set up ({{count}})",
    collection_setup_success: "{{name}} has been set up",
    go_to_collection: "Go to collection",
    add_your: "अपने",
    database_collections: "डेटाबेस संग्रह",
    to_firecms: "को FireCMS में जोड़ें",
    no_unmapped_collections: "कोई असंबद्ध संग्रह नहीं",
    query_and_update_with_datatalk: "DATATALK के साथ प्राकृतिक भाषा में अपना डेटा क्वेरी और अपडेट करें",
    welcome_to_firecms: "FireCMS में आपका स्वागत है",
    admin_panel_ready_bring_data: "आपका पैनल तैयार है। अपना डेटा जोड़कर शुरू करें।",
    admin_panel_ready_get_started: "शुरू करें",
    auto_detect_collections: "संग्रहों को स्वचालित रूप से पहचानें",
    auto_detect_collections_desc: "FireCMS आपके Firestore डेटा का विश्लेषण करेगा और आपके लिए संग्रहों को स्वचालित रूप से कॉन्फ़िगर करेगा",
    create_a_collection: "एक संग्रह बनाएं",
    create_collection_desc: "अपने संग्रह की संरचना मैन्युअल रूप से परिभाषित करें",
    read_the_docs: "दस्तावेज़ीकरण पढ़ें",
    read_the_docs_desc: "जानें कि FireCMS का अधिकतम उपयोग कैसे करें",
    explore_docs: "दस्तावेज़ीकरण देखें",
    want_to_customize_with_code: "क्या आप कोड से FireCMS को कस्टमाइज़ करना चाहते हैं?",
    to_scaffold_a_local_project: "एक स्थानीय प्रोजेक्ट बनाने के लिए",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "सत्यापन",
    unique: "अद्वितीय",
    required_message: "आवश्यक संदेश",
    required_tooltip: "यदि यह मान सेट नहीं है तो आप इस एंटिटी को सहेज नहीं पाएंगे",
    unique_tooltip: "एक ही मान वाली एक से अधिक एंटिटी नहीं हो सकतीं",
    lowercase: "लोअरकेस",
    uppercase: "अपरकेस",
    trim: "ट्रिम",
    exact_length: "सटीक लंबाई",
    min_length: "न्यूनतम लंबाई",
    max_length: "अधिकतम लंबाई",
    matches_regex: "रेजेक्स से मेल खाता है",
    not_valid_regexp: "वैध रेगुलर एक्सप्रेशन नहीं है",
    regex_helper: "उदा. /^\\d+$/ केवल अंकों के लिए",
    min_value: "न्यूनतम मान",
    max_value: "अधिकतम मान",
    less_than: "से कम",
    more_than: "से अधिक",
    positive_value: "सकारात्मक मान",
    negative_value: "नकारात्मक मान",
    integer_value: "पूर्णांक मान",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "अमान्य रेगुलर एक्सप्रेशन",
    must_specify_target_collection: "आपको फ़ील्ड के लिए एक लक्ष्य संग्रह निर्दिष्ट करना होगा",
    need_specify_repeat_field: "आपको एक दोहराव फ़ील्ड निर्दिष्ट करना होगा",
    need_specify_block_properties: "आपको इस ब्लॉक के गुण निर्दिष्ट करने होंगे",
    incomplete_condition: "अपूर्ण शर्त - कृपया एक फ़ील्ड चुनें",
    field_name: "फ़ील्ड का नाम",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "कानबन कॉलम प्रॉपर्टी",
    select_a_property: "एक प्रॉपर्टी चुनें",
    kanban_property_not_found: "प्रॉपर्टी \"{{property}}\" मौजूद नहीं है या एनम स्ट्रिंग प्रॉपर्टी नहीं है। कृपया एक वैध प्रॉपर्टी चुनें या चयन साफ़ करें।",
    no_enum_string_properties: "कोई एनम स्ट्रिंग प्रॉपर्टी नहीं मिली। कानबन दृश्य का उपयोग करने के लिए enumValues के साथ एक स्ट्रिंग प्रॉपर्टी जोड़ें।",
    kanban_column_description: "एंटिटीज़ को कॉलम में समूहित करने के लिए एनम मानों वाली एक स्ट्रिंग प्रॉपर्टी चुनें",
    create_property: "+ \"{{property}}\" प्रॉपर्टी बनाएं",
    order_property: "क्रम प्रॉपर्टी",
    order_property_not_found: "प्रॉपर्टी \"{{property}}\" मौजूद नहीं है या एक संख्या प्रॉपर्टी नहीं है। कृपया एक वैध प्रॉपर्टी चुनें या चयन साफ़ करें।",
    no_number_properties: "कोई संख्या प्रॉपर्टी नहीं मिली। क्रम सक्षम करने के लिए एक संख्या प्रॉपर्टी जोड़ें।",
    order_property_description: "आइटम का क्रम बनाए रखने के लिए एक संख्या प्रॉपर्टी चुनें",
    display_settings: "प्रदर्शन सेटिंग्स",
    default_row_size: "डिफ़ॉल्ट पंक्ति आकार",
    side_dialog_width: "साइड डायलॉग चौड़ाई",
    side_dialog_width_description: "वैकल्पिक रूप से एंटिटी साइड डायलॉग की चौड़ाई (पिक्सेल में) परिभाषित करें। डिफ़ॉल्ट 768px है",
    inline_editing_enabled: "डेटा को सीधे टेबल दृश्य में संपादित किया जा सकता है",
    inline_editing_disabled: "डेटा को केवल फ़ॉर्म दृश्य में संपादित किया जा सकता है",
    inline_editing_description: "फ़ॉर्म दृश्य खोले बिना सीधे टेबल दृश्य में डेटा संपादन की अनुमति दें।",
    include_json_view: "JSON दृश्य शामिल करें",
    no_json_view: "JSON दृश्य शामिल न करें",
    json_view_description: "दस्तावेज़ का JSON प्रतिनिधित्व शामिल करें।",
    not_found_suffix: "नहीं मिला",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "पाठ",
    editor_text_description: "बस सादे पाठ के साथ टाइप करना शुरू करें।",
    editor_heading_1: "शीर्षक 1",
    editor_heading_1_description: "बड़ा अनुभाग शीर्षक।",
    editor_heading_2: "शीर्षक 2",
    editor_heading_2_description: "मध्यम अनुभाग शीर्षक।",
    editor_heading_3: "शीर्षक 3",
    editor_heading_3_description: "छोटा अनुभाग शीर्षक।",
    editor_todo_list: "टू-डू सूची",
    editor_todo_list_description: "टू-डू सूची के साथ कार्यों को ट्रैक करें।",
    editor_bullet_list: "बुलेट सूची",
    editor_bullet_list_description: "एक सरल बुलेट सूची बनाएं।",
    editor_numbered_list: "क्रमांकित सूची",
    editor_numbered_list_description: "नंबरिंग के साथ एक सूची बनाएं।",
    editor_quote: "उद्धरण",
    editor_quote_description: "एक उद्धरण कैप्चर करें।",
    editor_code: "कोड",
    editor_code_description: "एक कोड स्निपेट कैप्चर करें।",
    editor_image: "छवि",
    editor_image_description: "अपने कंप्यूटर से एक छवि अपलोड करें।",
    editor_multiple: "एकाधिक",
    editor_link: "लिंक",
    editor_save: "सहेजें",
    editor_cancel: "रद्द करें",
    editor_remove_link: "लिंक हटाएं",
    editor_paste_or_type_link: "लिंक पेस्ट करें या टाइप करें",
    editor_open_in_new_window: "नई विंडो में खोलें",
    editor_bold: "बोल्ड",
    editor_italic: "इटैलिक",
    editor_underline: "अंडरलाइन",
    editor_strikethrough: "स्ट्राइकथ्रू",
    editor_autocomplete: "स्वतः पूर्ण",
    editor_autocomplete_description: "संदर्भ के आधार पर पाठ जोड़ें।",

    // ─── Cloud Project Settings ──────────────────────────────────
    settings_subscription_plan: "सदस्यता योजना",
    settings_subscribed_to: "आप वर्तमान में सदस्य हैं",
    settings_no_active_subscription: "वर्तमान में इस परियोजना के लिए कोई सक्रिय सदस्यता नहीं है।",
    settings_trial_valid_until: "आपका परीक्षण {{date}} तक वैध है।",
    settings_features_intro: "FireCMS Cloud का उपयोग करके आप पहले से इन सुविधाओं का आनंद ले रहे हैं",
    settings_feature_managed_service: "हमेशा अप-टू-डेट प्रबंधित सेवा",
    settings_feature_local_text_search: "स्थानीय पाठ खोज",
    settings_feature_unlimited_users_roles: "असीमित उपयोगकर्ता और भूमिकाएँ",
    settings_feature_theme_logo: "थीम और लोगो अनुकूलन",
    settings_feature_custom_fields_views: "कस्टम फॉर्म फ़ील्ड और कस्टम दृश्य",
    settings_feature_secondary_databases: "द्वितीयक डेटाबेस",
    settings_feature_ai_content: "OpenAI और Google के साथ AI सामग्री निर्माण",
    settings_feature_unlimited_export: "असीमित डेटा निर्यात",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "सेटिंग्स",
    settings_project_name: "परियोजना का नाम",
    settings_default_language: "डिफ़ॉल्ट भाषा",
    settings_default_language_caption: "इस परियोजना के लिए आधार भाषा चुनें। उपयोगकर्ता अपनी व्यक्तिगत सेटिंग्स में इस प्राथमिकता को बदल सकते हैं।",
    settings_enable_local_text_search: "स्थानीय पाठ खोज सक्षम करें",
    settings_local_text_search_caption: "सभी संग्रहों के लिए स्थानीय पाठ खोज सक्षम करें। इससे आप FireCMS खोज पट्टी का उपयोग करके अपने संग्रहों में पाठ फ़ील्ड खोज सकेंगे। ध्यान दें कि इस सुविधा के कारण अधिक पठन हो सकते हैं, क्योंकि यह आपके संग्रहों के सभी पाठ फ़ील्ड को अनुक्रमित करेगी।",
    settings_doc_history_all_collections: "सभी संग्रहों के लिए दस्तावेज़ इतिहास सक्षम",
    settings_doc_history_caption: "सक्षम होने पर, सभी संग्रहों में डिफ़ॉल्ट रूप से इतिहास सक्षम होगा। आप प्रत्येक संग्रह में इस सेटिंग को बदल सकते हैं। इतिहास प्रत्येक दस्तावेज़ की __history उपसंग्रह में सहेजा जाएगा।",
    settings_theme: "थीम",
    settings_primary_color: "प्राथमिक रंग",
    settings_secondary_color: "द्वितीयक रंग",
    settings_sample_theme_components: "नमूना थीम घटक",
    settings_drag_drop_logo: "अपना लोगो यहां खींचें और छोड़ें",
    settings_create_subscription: "सदस्यता बनाएं",
    settings_stripe_disclaimer: "आपकी सदस्यता पूरी करने के लिए Stripe पर पुनः निर्देशित किया जाएगा। मासिक बिलिंग आपके अधिकतम उपयोगकर्ताओं के आधार पर होती है। किसी भी समय रद्द करें – आपने वर्तमान बिलिंग अवधि के लिए पहले ही भुगतान कर दिया है, इसलिए रद्द करने के बाद कोई अतिरिक्त शुल्क नहीं लगेगा।",
    settings_subscription_is: "सदस्यता है",
    settings_next_payment_on: "अगला भुगतान {{date}} को है।",
    settings_seats_count: "आपके पास हैं",
    settings_seat: "सीट",
    settings_seats: "सीटें",
    settings_per_seat: "{{price}}/सीट/{{interval}} पर",
    settings_current_price: "वर्तमान मूल्य है",
    settings_per_user_usage: "प्रति उपयोगकर्ता (उपयोग-आधारित)।",
    settings_cancelled_active_until: "यह सदस्यता रद्द कर दी गई थी और {{date}} तक सक्रिय रहेगी।",
    settings_no_additional_charges: "रद्द करने के बाद कोई अतिरिक्त शुल्क नहीं लगेगा।",
    settings_manage_subscription: "सदस्यता प्रबंधित करें",
    settings_security_rules: "सुरक्षा नियम",
    settings_security_rules_description: "FireCMS डेटा तक पहुंच प्रतिबंधित करने के लिए Firebase सुरक्षा नियमों का उपयोग करता है। FireCMS के माध्यम से नया उपयोगकर्ता बनाते समय, कस्टम दावा fireCMSUser क्लाइंट प्रोजेक्ट में उपयोगकर्ता में जोड़ा जाता है। निम्नलिखित सुरक्षा नियम जोड़कर, आप सुनिश्चित करते हैं कि FireCMS उपयोगकर्ता FireCMS के माध्यम से डेटा तक पहुंच सकें।",
    settings_security_rules_add_domain: "कृपया अपने प्रदाता के अनुमत डोमेन में {{domain}} डोमेन जोड़ना याद रखें",
    settings_security_rules_caption: "ये नियम डेटा तक पहुंच को केवल FireCMS उपयोगकर्ताओं तक सीमित करते हैं, लेकिन डेटाबेस स्तर पर अनुमतियों को लागू नहीं करते। अनुमतियां फ्रंटएंड में लागू होती हैं, जो अधिकांश परियोजनाओं के लिए ठीक काम करती हैं। यदि आपको डेटाबेस स्तर पर अनुमतियां लागू करने की आवश्यकता है, तो आप इन सुरक्षा नियमों को संशोधित कर सकते हैं। उपयोगकर्ता को सौंपी गई भूमिकाएं Firebase प्रमाणीकरण टोकन में कस्टम दावों के रूप में सेट की जाती हैं, इसलिए आप उन्हें अपने सुरक्षा नियमों में उपयोग कर सकते हैं।",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "आप अपनी Firebase सेवाओं को दुरुपयोग से बचाने के लिए AppCheck सक्षम कर सकते हैं। इसे कॉन्फ़िगर करने के लिए Firebase दस्तावेज़ देखें। जब आपके पास एक प्रदाता सेट हो, तो आप इसे यहां सक्षम कर सकते हैं। आपको अपनी Firebase प्रोजेक्ट सेटिंग्स में एक सीक्रेट और FireCMS कॉन्फ़िगरेशन में एक साइट कुंजी प्रदान करनी होगी।",
    settings_appcheck_add_domain: "कृपया अपने प्रदाता के अनुमत डोमेन में {{domain}} डोमेन जोड़ना याद रखें",
    settings_appcheck_enable: "AppCheck सक्षम करें",
    settings_appcheck_site_key: "साइट कुंजी",
    settings_appcheck_update: "AppCheck अपडेट करें",
    settings_appcheck_refresh_note: "सहेजने के बाद परिवर्तन देखने के लिए आपको पृष्ठ को ताज़ा करने की आवश्यकता हो सकती है।",
    settings_appcheck_updated: "AppCheck अपडेट किया गया",
    settings_appcheck_error: "AppCheck अपडेट करने में त्रुटि",

    // --- Permission Error View ---
    missing_firestore_security_rules: "Firestore सुरक्षा नियम गायब हैं",
    firecms_cloud_requires_security_rule: "FireCMS Cloud को आपके Firestore में प्रमाणित उपयोगकर्ताओं को एक्सेस देने के लिए एक विशिष्ट सुरक्षा नियम की आवश्यकता है। संग्रह",
    cannot_be_accessed_without_it: "पर इसके बिना नहीं पहुंचा जा सकता।",
    required_security_rule: "आवश्यक सुरक्षा नियम",
    fix_automatically: "स्वचालित रूप से ठीक करें",
    open_firebase_rules: "Firebase नियम खोलें",
    security_rules_updated_successfully: "सुरक्षा नियम सफलतापूर्वक अपडेट किए गए! कृपया अपना डेटा लोड करने के लिए पेज को रीफ्रेश करें।",
    sec_rules_fixing: "ठीक किया जा रहा है...",
    sec_rules_fixed: "ठीक हो गया!",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "पाठ खोज सक्षम करें",
    text_search_local_not_recommended: "बड़ी संग्रहों के लिए स्थानीय पाठ खोज की अनुशंसा नहीं की जाती है।",
    text_search_local_fetch_warning: "ध्यान दें कि स्थानीय पाठ खोज सक्षम करने के लिए आपके संग्रह से सभी दस्तावेज़ प्राप्त करने और उन्हें ब्राउज़र में संग्रहीत करने की आवश्यकता होगी। बड़ी संग्रहों के लिए यह अक्षम हो सकता है और अतिरिक्त लागत भी लग सकती है।",
    text_search_external_suggestion: "बड़ी संग्रहों के लिए, Algolia या Elastic Search जैसे बाहरी खोज इंजन का उपयोग करने और अपनी कॉन्फ़िगरेशन में एक खोज प्रतिनिधि निर्दिष्ट करने की सलाह दी जाती है।",
    text_search_local_description: "स्थानीय पाठ खोज आपके संग्रह में पाठ खोज सक्षम करने का सबसे सरल तरीका है। यह ब्राउज़र में संग्रह के सभी दस्तावेज़ लोड करता है और खोज स्थानीय रूप से करता है। छोटी संग्रहों के लिए यह अनुशंसित विकल्प है।",
    text_search_own_implementation: "आपने अपना स्वयं का पाठ खोज नियंत्रक लागू किया है। आप अपने संग्रह के लिए पाठ खोज सक्षम कर सकते हैं।",
    text_search_enable_for_collection: "इस संग्रह के लिए सक्षम करें",
    text_search_enable_for_project: "प्रोजेक्ट के लिए सक्षम करें",
    text_search_enabled_snackbar: "स्थानीय पाठ खोज सक्षम की गई",

    // ─── GCP Marketplace ─────────────────────────────────────────
    marketplace_managed_by_gcp: "GCP Marketplace के माध्यम से प्रबंधित",
    marketplace_billing_note: "आपकी सदस्यता Google Cloud Marketplace के माध्यम से प्रबंधित है। योजना परिवर्तन, बिलिंग और रद्दीकरण GCP कंसोल में संभाले जाते हैं।",
    marketplace_manage_in_gcp_console: "GCP कंसोल में प्रबंधित करें",
    marketplace_plan_changes_note: "अपनी योजना बदलने या रद्द करने के लिए, अपने GCP Marketplace ऑर्डर पर जाएं।",
    marketplace_welcome_title: "GCP Marketplace से स्वागत है!",
    marketplace_welcome_subtitle: "आपकी Google Cloud Marketplace सदस्यता सक्रिय है। इसे लिंक करने के लिए एक मौजूदा प्रोजेक्ट चुनें या एक नया बनाएं।",
    marketplace_select_or_create_project: "प्रोजेक्ट चुनें या बनाएं",
    marketplace_link_project: "प्रोजेक्ट लिंक करें",
    marketplace_linking: "प्रोजेक्ट लिंक हो रहा है…",
    marketplace_link_success: "प्रोजेक्ट सफलतापूर्वक लिंक हो गया! रीडायरेक्ट हो रहा है…",
    marketplace_link_error: "प्रोजेक्ट लिंक करने में त्रुटि। कृपया पुनः प्रयास करें।",
    marketplace_no_account_id: "कोई GCP Marketplace खाता ID नहीं मिली। कृपया GCP Marketplace से शुरू करें।",
};
